import {Locale} from '@hebcal/hdate';
import poData from './pl.po.js';
Locale.addLocale('pl', poData);
